import { call, put, takeLatest } from "redux-saga/effects";
import * as authApis from "../apis/authApis"
import { LOGIN } from "../actions/types";
import { COMPANY_DATA_FAILED, COMPANY_DATA_LOADED, USER_DATA_FAILED, USER_DATA_LOADED } from "../actions/returnType";

export function* loginWorker(action) {
    try {
        const res = yield call(authApis.loginApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
            yield put({ type: USER_DATA_LOADED, data: res?.data?.data?.user });
            yield put({ type: COMPANY_DATA_LOADED, data: res?.data?.data?.company });
        } else {
            yield action.onError(res);
            yield put({
                type: USER_DATA_FAILED,
                data: res?.data,
            });
            yield put({
                type: COMPANY_DATA_FAILED,
                data: res?.data,
            });
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}


/**Watcher functions */

export function* loginWorkerWatcher() {
    yield takeLatest(LOGIN, loginWorker);
}